export default __webpack_public_path__ + "static/media/jessica_yu.5f027f35.jpg";